/**
 *
 * @license Royal Canin
 * @contributors :
 *  - Amar YASSA
 */

import { StateNamesEnum } from '@app/shared/utils/enums/state-names.enum';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ShareRecommendationState } from './share-recommendation.state';

const selectShareRecommendationState = createFeatureSelector<ShareRecommendationState>(StateNamesEnum.SHARE_RECOMMENDATION_STATE_NAME);

export const selectShareRecommendationData = createSelector(
  selectShareRecommendationState,
  (state: ShareRecommendationState) => state?.data
);
